module.exports = __webpack_public_path__ + "img/103015.03c72260.png";